var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"pdfSignatureModal",attrs:{"id":"pdf-signature-modal","header-class":"anchor-modal","title":(_vm.title + " - Signature"),"hide-footer":"","size":"lg"}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"preview-container"},[(_vm.link)?_c('iframe',{attrs:{"src":_vm.link,"width":"100%","height":"100%"}}):_vm._e()])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cdc6da1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/PdfSignature.vue
// module id = null
// module chunks = 